import React from 'react';
import { Image, Text, View } from 'react-native-web';
import { Android, Change_payment_date } from '../../../../../utils/DictionaryManagementUtils';
import { getRef, LocStr } from '../../../../../utils/Utils';
import { img_android_screen_date_picker, img_ios_screen_date_picker } from '../../../../../utils/ImagesManagementUtils';

const DiaryImageFP = ({
  globJSON,
  simPlatform,
  language,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    lblPhoneTitle: {
      width: 240,
      height: 20,
      fontFamily: 'Quicksand-SemiBold',
      fontSize: 16,
      marginBottom: 5,
      color: '#001a2f',
    },
    phoneImage: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      backgroundColor: colors.app_background_color,
    },
  };

  return (

    <View ref={getRef(slideshowRefs)}>
      <Text style={[myStyles.lblPhoneTitle]}>
        {LocStr(Change_payment_date, language)}
      </Text>
      <Image
        fadeDuration={0}
        style={myStyles.phoneImage}
        source={simPlatform === Android ? img_android_screen_date_picker : img_ios_screen_date_picker}
      />
    </View>

  );
};

export default DiaryImageFP;
